import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AssignmentResultFilter } from '@app/pages/admin/assignment-result-count.util';

interface ResultFilterChip {
  id: AssignmentResultFilter;
  label: string;
  selected: boolean;
}

@Component({
  selector: 'app-assignment-result-filter',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './assignment-result-filter.html',
  styleUrl: './assignment-result-filter.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentResultFilterComponent {
  readonly selected = input<AssignmentResultFilter>('positive');
  readonly selectedChange = output<AssignmentResultFilter>();

  readonly chips = computed<ResultFilterChip[]>(() => {
    const selected = this.selected();
    return [
      { id: 'all', label: 'All', selected: selected === 'all' },
      { id: 'positive', label: 'Positive results', selected: selected === 'positive' },
    ];
  });

  select(filter: AssignmentResultFilter): void {
    if (filter === this.selected()) {
      return;
    }
    this.selectedChange.emit(filter);
  }
}
